import type { FC, SVGProps } from 'react';

import ChevronDownIconSvg from './chevron-down.svg';

/** Иконка шеврона вниз (индикатор выпадающего списка месяца/года в календаре). */
const ChevronDownIcon: FC<SVGProps<SVGSVGElement>> = ChevronDownIconSvg;

export default ChevronDownIcon;
